<gbc-tile [title]="title">
  @if (currentPeriod$ | async) {
    <gbc-tile-filter-tab
      [options]="filterOptions"
      (selectionChange)="selectPeriod($event)"
      [initialValue]="currentPeriod$ | async"
    ></gbc-tile-filter-tab>
  }
  @if (error) {
    <div class="spinner-container">
      {{ errorMessage | translate }}
    </div>
  }
  @if (spinner && !error) {
    <div class="spinner-container">
      <gbc-loading-spinner></gbc-loading-spinner>
    </div>
  }
  @if (!spinner && !error) {
    <app-chart [options]="options" [series]="series$"></app-chart>
  }
</gbc-tile>
